<template>
  <div class="product-list">
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-white control-box" style="padding: 20px">
          <div class="left">
            <!--                        <div class="select-box">-->
            <!--                            <el-input v-model="search.customerName" :placeholder="$lange == 'en' ? 'Customer' : '客户名称'" size="mini">-->
            <!--                                <i slot="prefix" class="el-input__icon el-icon-search"></i>-->
            <!--                            </el-input>-->
            <!--                        </div>-->
            <div class="select-box">
              <el-input v-model="search.jobId" placeholder="JOBID" size="mini">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="select-box">
              <cc-constant-selector
                style="display: inline-block"
                type="select"
                valType="String"
                :placeholder="$lange == 'en' ? 'Status' : '状态'"
                v-model="search.status"
                code="productStatus"
                api="admin/dict/pageTree"
              />
            </div>
            <div class="select-box">
              <cc-constant-selector
                style="display: inline-block"
                type="select"
                valType="String"
                :placeholder="$lange == 'en' ? 'Product line' : '产品线'"
                v-model="search.productLine"
                code="productLine"
                api="admin/dict/pageTree"
              />
            </div>
            <div class="select-box">
              <el-input
                size="mini"
                style="width: 200px"
                v-model="search.fasId"
                :placeholder="$lange == 'en' ? 'Project No.' : 'FAS'"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="select-box">
              <el-button type="primary" size="mini" @click="doSearch">{{
                $lange == "en" ? "Search" : "搜索"
              }}</el-button>
            </div>
            <div class="select-box">
              <el-button
                type="primary"
                size="mini"
                @click="goPage('/admin/product/create')"
                >{{ $lange == "en" ? "Create Product" : "创建产品" }}</el-button
              >
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <cc-table
      :config="tableConfig"
      :params="search2"
      :refesh-params="refeshTable"
    ></cc-table>
  </div>
</template>

<script>
// import defaultIcon from "../../assets/default.png"
// import warningIcon from "../../assets/warning.png"
// import primaryIcon from "../../assets/primary.png"
// import dangerIcon from "../../assets/danger.png"
import mapComponent from "../component/mapComponent";
export default {
  name: "ProductList",
  components: {},
  data() {
    return {
      search: {
        jobId: "",
        status: "",
        productLine: "",
        fasId: "",
      },
      search2: {
        jobId: "",
        status: "",
        productLine: "",
        fasId: "",
      },
      value: "",
      refeshTable: -1,
      tableConfig: {
        api: "admin/fsb/product/query",
        pageSize: 10,
        showPager: true,
        columns: [
          {
            prop: "jobId",
            lable: "JOBID",
            minWidth: 120,
          },
          {
            prop: "customerName",
            lable: this.$lange == "en" ? "Customer Name" : "客户名称",
            render: (row) => {
              let res = "---";
              if (row.customer) {
                res = row.customer.customerName;
              }
              return res;
            },
            minWidth: 160,
          },
          {
            prop: "fasId",
            lable: "FAS",
            minWidth: 120,
          },
          {
            prop: "managerName",
            lable: this.$lange == "en" ? "Project Manager" : "项目经理",
            minWidth: 120,
          },
          {
            prop: "productLine",
            lable: this.$lange == "en" ? "Product Line" : "产品线",
          },
          {
            prop: "speed",
            lable: this.$lange == "en" ? "Speed" : "速度",
            minWidth: 120,
          },
          {
            prop: "breadth",
            lable: this.$lange == "en" ? "Width" : "幅宽",
          },
          {
            prop: "stackedLayers",
            lable: this.$lange == "en" ? "Stacked Layers" : "堆叠层数",
          },
          {
            prop: "corrugatedLayers",
            lable: this.$lange == "en" ? "Corrugated Layers" : "瓦楞层数",
          },
          {
            prop: "bootTime",
            lable: this.$lange == "en" ? "Turn on Time" : "开机时间",
              minWidth: 160,
          },
          {
            prop: "warrantyTime",
            lable: this.$lange == "en" ? "Warranty Time" : "保修时间",
            minWidth: 180,
          },
          {
            prop: "status",
            lable: this.$lange == "en" ? "Status" : "状态",
            // type: "tag",
            // options: [
            //   { tagType: "info", text: "新增" },
            //   { tagType: "warning", text: "安装" },
            //   { tagType: "success", text: "保内" },
            //   { tagType: "danger", text: "保外" },
            // ],
            type: "constant",
            constantConfig: {
              code: "productStatus",
              api: "admin/dict/pageTree",
              opts: { 0: "info", 1: "warning", 2: "success", 3: "danger" },
            },
            minWidth: this.$lange == "en" ? 130 : 80,
          },
          {
            prop: "createTime",
            lable: this.$lange == "en" ? "Create Time" : "创建时间",
            minWidth: 160,
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "View Detail" : "查看",
            click: (row) => {
              this.$router.push({
                path: "/admin/product/description",
                query: {
                  productId: row.id,
                },
              });
            },
          },
          {
            name: this.$lange == "en" ? "Delete" : "刪除",
            click: (row) => {
              this.delete(row);
            },
          },
        ],
      },
    };
  },
  methods: {
    doSearch() {
      this.search2 = { ...this.search };
    },
    goPage(path) {
      this.$router.push({
        path: path,
      });
    },
    delete(e) {
      this.$confirm("此操作将永久删除该产品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            id: e.id,
          };
          this.ccRequest
            .do("admin/fsb/product/deleteById", data, "GET")
            .then((res) => {
              this.$message({
                type: "success",
                message: "刪除成功",
              });
              this.refeshTable = new Date().getTime();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.product-list {
  height: 100%;
  display: flex;
  flex-direction: column;

  .control-box {
    display: flex;
    justify-content: space-between;
    background: #ffffff;
    .select-box {
      display: inline-block;

      &:not(:first-child) {
        margin-left: 20px;
      }
    }
  }
}
</style>
